type NoError = {
  params: Array<string | null | undefined>;
};

export const hasNoError = ({ params }: NoError): boolean => {
  const existParams = params.filter((param) => param !== undefined);
  return existParams.every((error?: string | null) => error === null);
};
